import { render, staticRenderFns } from "./afs-detail.vue?vue&type=template&id=554eaa2f"
import script from "./afs-detail.vue?vue&type=script&lang=js"
export * from "./afs-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports